import React from 'react';
import { LightBackground } from 'scy/Background';
import styles from './styles.mod.scss';

export default function RoundUpSection({ children }) {
  return (
    <LightBackground tag="section" className={styles.section}>
      {children}
    </LightBackground>
  );
}
